const getStyles = (props) => {
  return {
    container: {
      background: 'linear-gradient(to bottom, #eaeaea, #ffffff)',
      color: '#333',
      padding: '20px',
      borderRadius: '10px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      fontFamily: 'Raleway',
      lineHeight: '1.8',
      opacity: props.isVisible ? 1 : 0,
      transform: props.isVisible ? 'translateY(0)' : 'translateY(20px)',
      transition: 'opacity 0.8s ease, transform 0.8s ease'
    },
    heading: {
      fontSize: '32px',
      fontWeight: 'bold',
      marginBottom: '16px',
      textAlign: 'center'
    },
    subheading: {
      fontSize: '20px',
      fontWeight: 'bold',
      margin: '16px 0 8px',
      textAlign: props?.isMobile ? 'center' : 'start'
    },
    paragraph: {
      marginBottom: '16px',
      textAlign: props?.isMobile ? 'center' : 'start'
    },
    list: {
      paddingLeft: '20px',
      marginBottom: '16px'
    },
    listItem: {
      marginBottom: '8px'
    },
    images: {
      display: 'block',
      margin: '20px auto',
      width: '100%',
      maxWidth: '400px',
      borderRadius: '10px'
    }
  };
};

export default getStyles;
